/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/**
 * Build a consistent production/event payload for dataLayer events.
 */
export class DataLayerPayload {
    id: string;
    name: string;
    date: string;
    category: string;
    production: string;
    location: string;
    hall: string;

    constructor(
        id: string,
        title: string,
        subtitle: string,
        date: string,
        category: string,
        production: string,
        location: string,
        hall: string
    ) {
        this.id = id; // box office id of the event
        this.name = title + (subtitle ? ' - ' : '') + subtitle;
        this.date = moment(date, 'YYYY-MM-DD hh:mm:ss').format();
        this.category = category; // default or movie, or the type of product
        this.production = production; // production code, typically the yesplan id
        this.location = location; // building or venue
        this.hall = hall; // hall in that location
    }

    /**
     * Build a payload matching our custom order_items layout.
     */
    build(): Object {
        return {
            item_date: this.date,
            item_name: this.name,
            item_code: this.id, // just for backwards compatibility, item_id is leading
            item_id: this.id,
            item_type: this.category, // just for backwards compatibility, item_category is leading
            item_category: this.category,
            item_production: this.production,
            item_location: this.location,
            item_hall: this.hall,
            products: [],
            products_value: 0
        };
    }

    /**
     * Build a payload matching GA4's standard ecommerce layout.
     *
     * https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#make_a_purchase_or_issue_a_refund
     */
    buildGa4(): Object {
        return {
            item_id: this.id,
            item_name: this.name,
            // affiliation: '', not required
            // coupon: '', not required
            // discount: 0, not required
            // index: potentially dataLayer[0].ga4_ecommerce_items.length, but not required
            // item_brand: '', not required
            item_category: this.category,
            // item_category2: '',not required
            // item_category3: '',not required
            // item_category4: '',not required
            // item_category5: '',not required
            // item_list_id: '',not required
            // item_list_name: '',not required
            // item_variant: '',not required
            // location_id: '',not required
            price: 0, // this will become the unit price (average price per ticket)
            quantity: 1 // this will become the total number of tickets for this event
        };
    }
}
